module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-trend-1-ea0348e1e19ce2e66bd8c58f716d9452.jpg";